/* eslint-disable no-nested-ternary */
/* eslint-disable no-prototype-builtins */
import { useState } from "react";
import "./Filter.scss";
import Button from "components/v2/Button/Button";
import Badge from "components/v2/Badge/Badge";
import { ReactComponent as FilterIcon } from "assets/images/iconsV2/filter-lines.svg";

import { FilterConfig } from "types/Common";
import Drawer from "components/v2/Drawer/Drawer";
import DrawerHeader from "components/v2/Drawer/components/DrawerHeader/DrawerHeader";
import DrawerFooter from "components/v2/Drawer/components/DrawerFooter/DrawerFooter";
import FilterAccordions from "./components/FilterAccordions";

type FilterProps = {
  /**
   * Configuration for the filters
   */
  config: Array<FilterConfig>;
  /**
   * Current filters that are applied
   */
  currentFilters: Record<string, any>;
  /**
   * Function to set the current filters
   */
  setCurrentFilters: Function;
  /**
   * Event context for tracking purposes
   */
  eventContext: string;
};
function Filter({ config, currentFilters, setCurrentFilters, eventContext }: FilterProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [pendingFilters, setPendingFilters] = useState(currentFilters); // Filters that are yet to be applied

  // Reset the pending filters, still needs to be applied by the user to take effect
  const resetFilters = () => {
    setPendingFilters({});
  };
  // Apply any pending filters to the currentFilters
  const applyFilters = () => {
    setCurrentFilters(pendingFilters);
    setIsOpen(false);
  };
  // Close the offcanvas and clear any pending filters that were not applied
  const handleClose = () => {
    setIsOpen(false);
    setPendingFilters(currentFilters);
  };

  // Counts total amount of filters applied, shown in the filters button badge
  const countFilters = (filters: Record<string, any>): number =>
    Object.values(filters).reduce(
      (count, value) =>
        Array.isArray(value)
          ? count + value.length
          : (typeof value === "object" && value !== null) ||
            (typeof value === "string" && value.trim()) ||
            typeof value === "number" ||
            typeof value === "boolean"
          ? count + 1
          : count,
      0,
    );

  return (
    <>
      <Button
        label="Filters"
        variant="secondary-gray"
        iconLeft={<FilterIcon />}
        iconRight={<Badge label={countFilters(pendingFilters)} color="gray" type="category-badge" />}
        size="sm"
        onClick={() => setIsOpen(true)}
      />
      <Drawer size="sm" isOpen={isOpen} onClose={handleClose}>
        <DrawerHeader title="Filters" supportingText="Apply filters to table data" />
        <FilterAccordions
          config={config}
          pendingFilters={pendingFilters}
          setPendingFilters={setPendingFilters}
          eventContext={eventContext}
        />
        <DrawerFooter>
          <div className="d-flex justify-content-between align-items-between w-100">
            <Button variant="link-color" onClick={resetFilters} label="Reset filters" />
            <div className="d-flex">
              <div className="mr-lg">
                <Button variant="secondary-gray" onClick={() => setIsOpen(false)} label="Cancel" />
              </div>
              <Button variant="primary" onClick={applyFilters} label="Apply" />
            </div>
          </div>
        </DrawerFooter>
      </Drawer>
    </>
  );
}
export default Filter;
